import { Grid } from '@material-ui/core';
import { useDevice } from 'components/DeviceContext.js';
import { Card1, Card2 } from 'components/Card';

const TextoPresidente = () => {
    const { isMobile } = useDevice();

    return (
        <>
            <Grid container
                style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    maxHeight: isMobile ? '100%' : '100%',
                    fontFamily: 'Open sans',
                    flexDirection: isMobile ? 'column' : '',
                    margin: isMobile ? '' : '2em 0 5em'
                }}>
                <Grid item xs={12} md={5} xl={5}
                    style={{
                        textAlign: 'justify',
                        padding: isMobile ? '2em 2em' : '',
                        fontSize: isMobile ? '12px' : '16px'
                    }}>
                    <h1
                        style={{
                            color: 'var(--azul)',
                            fontSize: '2em'
                        }}>Palavra do presidente</h1>
                    <p>
                        Uma sociedade comprometida com acesso, garantia de direitos e melhoria da qualidade de vida de sua população é resultado
                        de um Município alinhado às questões da infância e da adolescência, tendo-as como fundamentais para o desenvolvimento social de suas cidades.
                    </p>
                    <p>
                        Consciente de que o dever de zelar pelo desenvolvimento das crianças e dos adolescentes não é exclusividade do Estado,
                        mas sim de toda a sociedade, a Confederação Nacional de Municípios (CNM) e as entidades apoiadoras mobilizam pelo segundo
                        ano a campanha nacional on-line <span>“Municípios pela infância e adolescência”.</span>
                    </p>
                    <p>
                        Nesse sentido, como forma de subsidiar os Municípios no aprimoramento financeiro e técnico de suas políticas públicas, a
                        CNM orienta a criação, a regularização e o cadastramento do Fundo para Infância e Adolescência (FIA). E, assim,
                        incentivar a população a realizar doações ao FIA por meio da destinação de parte do imposto de renda devido.
                        Nessa campanha, pessoa física e/ou pessoa jurídica podem participar.
                    </p>
                    <p>
                        Os Fias municipais são instrumentos que podem auxiliar o poder público a melhorar suas receitas e, dessa maneira,
                        potencializar áreas estratégicas. Além disso, a CNM reconhece o Fundo como um importante e estratégico mecanismo de
                        participação da sociedade civil na construção, na promoção, na defesa e no fortalecimento da garantia dos direitos
                        das crianças e dos adolescentes.
                    </p>
                    <p>
                        A campanha de caráter nacional tem a finalidade de sensibilizar e mobilizar os 5.568 Municípios, os prefeitos, os profissionais,
                        os Conselhos Municipais dos Direitos da Criança e do Adolescente (CMDCA), os gestores municipais e os demais atores, com o propósito
                        de captar recursos para complementar as receitas dos Fundos municipais e custear a implantação e a execução de projetos sociais locais,
                        programas, ações e serviços dirigidos ao atendimento dos direitos de crianças e adolescentes.
                    </p>
                    <p>
                        Presidente da CNM <br />
                        <span style={{ fontWeight: '600' }}>Paulo Ziulkoski</span>
                    </p>


                </Grid>
                <Grid item xs={12} md={5} xl={4} style={{
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    <Card1 />
                    <Card2 />

                </Grid>
            </Grid>
        </>
    )
}

export default TextoPresidente;
